import { useEffect, useState } from "react";
import { ShieldCheck, RefreshCw } from "lucide-react";
import api from "../lib/api";

const METHOD_COLOR = {
  POST: "var(--su-success)",
  PUT: "var(--su-energy)",
  PATCH: "var(--su-energy)",
  DELETE: "var(--su-danger)",
};

function fmtTime(iso) {
  try {
    return new Date(iso).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return iso;
  }
}

export default function AdminAudit() {
  const [logs, setLogs] = useState(null);

  const load = () => api.get("/admin/audit-logs?limit=200").then(({ data }) => setLogs(data.logs)).catch(() => setLogs([]));
  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-4" data-testid="admin-audit">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <ShieldCheck className="w-5 h-5 text-su-primary" />
          <h2 className="font-heading font-black text-lg">Log Aktivitas Admin</h2>
        </div>
        <button data-testid="audit-refresh" onClick={load} className="inline-flex items-center gap-2 px-3 py-2 rounded-xl border-2 border-su-border bg-su-surface font-heading font-extrabold text-sm hover:border-su-primary">
          <RefreshCw className="w-4 h-4" /> Muat Ulang
        </button>
      </div>
      <p className="text-su-muted font-medium text-sm">Semua aksi perubahan (buat/ubah/hapus) oleh admin tercatat otomatis di sini untuk keamanan & audit.</p>

      {logs === null ? (
        <div className="min-h-[30vh] grid place-items-center"><div className="w-10 h-10 rounded-full border-4 border-su-border border-t-su-primary animate-spin" /></div>
      ) : logs.length === 0 ? (
        <div className="card-chunky p-8 text-center text-su-muted font-medium">Belum ada aktivitas admin tercatat.</div>
      ) : (
        <div className="card-chunky overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left border-b-2 border-su-border">
                <th className="p-3 font-heading font-black text-su-muted uppercase text-xs">Waktu</th>
                <th className="p-3 font-heading font-black text-su-muted uppercase text-xs">Admin</th>
                <th className="p-3 font-heading font-black text-su-muted uppercase text-xs">Metode</th>
                <th className="p-3 font-heading font-black text-su-muted uppercase text-xs">Aksi</th>
                <th className="p-3 font-heading font-black text-su-muted uppercase text-xs">Status</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l.log_id} className="border-b border-su-border/50" data-testid={`audit-row-${l.log_id}`}>
                  <td className="p-3 font-mono text-xs text-su-muted whitespace-nowrap">{fmtTime(l.created_at)}</td>
                  <td className="p-3 font-semibold">{l.admin_email}</td>
                  <td className="p-3">
                    <span className="px-2 py-0.5 rounded-lg font-heading font-black text-xs text-black" style={{ background: METHOD_COLOR[l.method] || "var(--su-muted)" }}>{l.method}</span>
                  </td>
                  <td className="p-3 font-mono text-xs">{l.action}</td>
                  <td className="p-3 font-heading font-black" style={{ color: l.status >= 400 ? "var(--su-danger)" : "var(--su-success)" }}>{l.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
